if (!customElements.get('klaviyo-form')) {
  const KlaviyoForm = class extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.klaviyo-form-container');
      this.statusContainer = this.querySelector('.form-status');
      this.form = this.querySelector('form');
      this.listId = this.form.dataset.listId;
      
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      // this.form.querySelectorAll('input:not([type="checkbox"])');
      this.form.querySelectorAll('input:not([type="checkbox"])').forEach(e => {
        e.addEventListener('focus', this.handleConsent.bind(this))
        // if(e.closest('.form-field').querySelector('.agreement-block') != undefined){
        //   e.closest('.form-field').querySelector('.agreement-block').classList.add('hidden');
        // }
      })
    }

    async handleSubmit(evt){
      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.querySelector('.form-status').innerHTML = ``;

      const formData = new FormData(this.form);

      if (!this.validate()) return;

        const emailInput = this.form.querySelector('.email');
        const phoneInput = this.form.querySelector('.phone');

        const payload = {
          data: {
            type: "subscription",
            attributes: {
              custom_source: "form",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput ? emailInput.value : "",
                    phone_number: phoneInput ? phoneInput.value : "",
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: this.listId
                }
              }
            }
          }
        };

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2026-01-15"
          },
          body: JSON.stringify(payload),
      };

      const res = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=PsjVpw",requestOptions)
          .then(res => {return res;})
          .catch(error => console.log('error', error));

          // console.log(res);
      if(res.ok && res.ok == true){
        this.querySelector('.form-status').innerHTML = `<p class="success">You're added in the list!</p>`;

        if(emailInput){
          alert();
            window.ElevarDataLayer.push({
              event: "dl_subscribe",
              lead_type: "email",
              user_properties: { customer_email: emailInput.value }
            });
          }

        // this.form.classList.add('hidden');
        this.form.reset();
        /* remove after 5 seconds */
        setTimeout(() => {
          this.querySelector('.form-status').innerHTML = '';
          // this.form.classList.remove('hidden');
        }, 5000);
      }else{
        if(!res.errors){
          this.querySelector('.form-status').innerHTML = `<p class="error">${res.errors[0].detail}</p>`;
        }
      }
    }
    
    validate(){
      let valid = true;
      if(this.form.querySelector('.agreement-block') != undefined){
        this.form.querySelectorAll('.agreement-block').forEach(el => {
          if(el.querySelector('[type="checkbox"]').checked != true){
            this.querySelector('.form-status').innerHTML = `<p class="error">Please accept the terms.</p>`;
            valid = false;
          }
        })
      }
      return valid;
    }

    handleConsent(evt){
      if(evt.target.closest('.form-field').querySelector('.agreement-block') != undefined){
        evt.target.closest('.form-field').querySelector('.agreement-block').classList.remove('hidden');
      }
    }
  }
  window.customElements.define('klaviyo-form', KlaviyoForm);
}